import React from "react";
import { Container } from "react-bootstrap";

const PageEnd = () => {
  return (
    <Container>
      <section id="page-end" className="pt-5 ">
        <div className="circle brown mt-5"></div>
      </section>
    </Container>
  );
};

export default PageEnd;
